export default {"src":"/_next/static/media/oxy.49d3328e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};